export default __webpack_public_path__ + "static/media/cdlog_v2.2b663a16.jpg";